import { AssetsFileFormViewModel } from './assets-file-form.viewmodel';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { ITitleAssetUrlDTO } from '../../../../../api/assets.dao';
import { AssetsFileFormPresentation } from './assets-file-form.presentation';

interface ContainerProps {
    accountId: number;
    eventId: number;
    organizationId?: number | null;
    attendeeId?: number | null;
    file: ITitleAssetUrlDTO;
    closeAssetsFilePopup: () => void;
    onDeleteAsset: (objectKey: string) => void;
    uploadProfileImage: (file: File, organizationId: number, attendeeId: number) => void;
    fileProtected?: boolean;
}

const AssetsFileFormContainer = withViewModel(AssetsFileFormPresentation, (props: ContainerProps) => {
    const vm = new AssetsFileFormViewModel(
        props.accountId,
        props.eventId,
        props.organizationId,
        props.attendeeId,
        props.file,
        props.closeAssetsFilePopup,
        props.onDeleteAsset,
        props.uploadProfileImage,
        !!props.fileProtected
    );
    return vm;
});

export { AssetsFileFormContainer as AssetsFileForm };
